import { REVALIDATE_COMPONENT } from "../actions/types";

export default (response = null, action) => {
  if (action.type === REVALIDATE_COMPONENT) {
    return action.payload;
  }
  return response;
};
